export const menuSideBarItems = [
    {
        text: 'Owlets (age 6-10)',
        url: 'HOME'       
    },
    { 
        text: 'Owls (age 11-14)',
        url: 'HOME' 
    },
    {
        text: 'My account',
        url: ''
    },
    {
        text: 'My contributions',
        url: ''
    },
    {
        text: 'Help',
        url: ''
    },
    {
        text: 'Change language',
        url: 'LANGUAGE'
    }
  ]
